import { createNotificationsSlice, notificationsInitialState } from '@sv-support-sdk/store';

const notifications = createNotificationsSlice({
  name: 'notifications',
  initialState: { ...notificationsInitialState },
  reducers: {},
});

export const notificationActions = notifications.actions;

export default notifications.reducer;
